module.exports = __webpack_public_path__ + "static/media/186.e6a42dea.webp";